import { useEffect, useMemo, useState } from "react"
import { useParams } from "react-router-dom";
import { tgjHeader } from "../Tabellen/ConstTabKopf/TagesgruppenJahrKopf";
import TableWithoutSpecials from "../Tabellen/TableWithoutSpecials";
import TagesgruppenJahrUpdate from "./TagesgruppenJahrUpdate";

export default function TagesgruppenJahrTabelle ({gruppeZuJahrInstance}) {
    const { uniqueYear } = useParams();
    const [currentData, setCurrentData] = useState([]);

    useEffect(() => {
        console.log('>>aufruf ', uniqueYear);
        gruppeZuJahrInstance.getAllTagesgruppenForOneYear(uniqueYear, (error, data) => {
            if (error) {
                console.log(error);
            } else {
                console.log('>>neu', data);
                setCurrentData(data);
            }
        });
    }, [gruppeZuJahrInstance, uniqueYear]);
    
    const reloadData = (jahr) => {
        setCurrentData([]);
        console.log('jahr:', jahr)
        gruppeZuJahrInstance.getAllTagesgruppenForOneYear(jahr, (error, data) => {
            if (error) {
                console.log(error);
            } else {
                console.log('>>neu');
                setCurrentData(data);
            }
        });
    }
    const prepData = useMemo(() => currentData, [currentData]);
    const additionalColumn =                 
        {
            id: "update",
            Header: "",
            Cell: ({ row }) => (
                <div>
                    <TagesgruppenJahrUpdate rowEntry={row.original} instance={gruppeZuJahrInstance} reloadData={reloadData}/>
                </div>
            )
        }
    return (
        <div>
            {currentData.length > 0 &&
                <TableWithoutSpecials 
                    data={prepData} 
                    columns={tgjHeader} 
                    hiddenColumns={['idGruppe', 'jahr']} 
                    additionalColumns={additionalColumn}
                    reloadData={reloadData}
                />}

            {currentData.length === 0 && 
                <p>--- Für dieses Jahr sind noch keine Daten hinterlegt. (Umsetzung zum Neuanlegen analog zu Einwohner) ---</p>}
        </div>
    )
}